import * as React from "react"
import {SvgFunction} from "@web-libs/ui/svgs/types";
const ProfileIcon:SvgFunction = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? 32}
        height={props.height ?? 32}
        viewBox={"0 0 32 32"}
    >
        <g fill={props.fill}>
            <path d="M16 16a8 8 0 1 0-8-8 8.008 8.008 0 0 0 8 8Zm0-13.333a5.333 5.333 0 1 1 0 10.666 5.333 5.333 0 0 1 0-10.666ZM16 18.667a12.013 12.013 0 0 0-12 12 1.333 1.333 0 0 0 2.667 0 9.333 9.333 0 0 1 18.666 0 1.333 1.333 0 0 0 2.667 0 12.013 12.013 0 0 0-12-12Z" />
        </g>
    </svg>
)
export default ProfileIcon
